module.exports = __webpack_public_path__ + "img/logo.42304121.png";